module.exports = __webpack_public_path__ + "media/images/icons/outlined/file-done-edec6798c252bc064f46db4062f958b2.svg";